import { Match, MediaSource, CodeEventGroup, MatchEvent, Button, ButtonSet } from '../../models';
import { IFileImporter } from '../IFileConverter';
import * as functions from '../../common/functions';

export class SportsCodeFileImporter implements IFileImporter {
  public name = 'SportsCode';

  private static processButtonConfiguration(dom: Document): ButtonSet {
    const buttonConfiguration = [] as Button[];

    if (dom !== undefined && dom !== null) {
      const instances = dom.getElementsByTagName('instance');
      for (let i = 0; i < instances.length; i++) {
        const identifier = instances[i].getElementsByTagName('ID')[0].textContent;
        const code = instances[i].getElementsByTagName('code')[0].textContent;

        const item = buttonConfiguration.find(e => e.eventType === code);

        if (item === null || item === undefined) {
          buttonConfiguration.push({
            identifier: identifier,
            eventType: code,
            color: 'blue',
            leadSeconds: 5,
            lagSeconds: 5
          } as Button);
        }
      }
    }

    return {
      name: '',
      userId: '',
      buttons: buttonConfiguration
    };
  }

  private static processCodedEvents(dom: Document, buttons: Button[]): CodeEventGroup[] {
    const codedEventTypes = [] as CodeEventGroup[];

    if (dom !== undefined && dom !== null) {
      const instances = dom.getElementsByTagName('instance');
      for (let i = 0; i < instances.length; i++) {
        const identifier = instances[i].getElementsByTagName('ID')[0].textContent;
        const code = instances[i].getElementsByTagName('code')[0].textContent;
        const start = instances[i].getElementsByTagName('start')[0].textContent;
        const end = instances[i].getElementsByTagName('end')[0].textContent;

        let item = codedEventTypes.find(e => e.eventType === code);

        if (item === null || item === undefined) {
          item = {
            eventType: code,
            events: []
          } as CodeEventGroup;

          codedEventTypes.push(item);
        }

        const seconds = (+start + +end) / 2;
        const leadSeconds = seconds - (+start);
        const lagSeconds = (+end) - seconds;

        const matchEvent = {
          eventType: code,
          color: (code.startsWith('T2 ')) ? 'blue' : (code === 'P1' || code === 'P2') ? 'yellow' : 'red',
          seconds: Math.round(seconds),
          leadSeconds: leadSeconds,
          lagSeconds: lagSeconds,
          comments: ''
        } as MatchEvent;

        if (instances[i].getElementsByTagName('label') && instances[i].getElementsByTagName('label')[0]) {
          const el = instances[i].getElementsByTagName('label')[0];
          if (el.getElementsByTagName('text')) {
            const tag = `${el.getElementsByTagName('text')[0].textContent}`;
            matchEvent.tags = [tag];
          }
        }

        item.events.push(matchEvent);
      }
    }

    return codedEventTypes.filter(e => e !== undefined);
  }

  private static processProperties(dom: Document): Match {
    if (dom !== undefined && dom !== null) {
      const properties = {
        competitionName: '',
        awayTeam: '',
        homeTeam: '',
        grade: '',
        year: new Date().getFullYear(),
        matchName: '',
      //   matchDate: new Date().toDateString(),
        roundNumber: 0,
        venue: '',
        userId: '',
        media: {} as MediaSource,
        identifier: '',
        buttonSetId: null,
        isPublished: false,
        isCurrentPublished: false,
        events: []
      } as Match;

      return properties;
    }

    return {} as Match;
  }

  public convert(input: string): Match {
    const oParser = new DOMParser();
    const oDOM = oParser.parseFromString(input, 'text/xml');
    // print the name of the root element or error message
    console.log(
      oDOM.documentElement.nodeName === 'parsererror'
        ? 'error while parsing'
        : oDOM.documentElement.nodeName
    );

    const match = SportsCodeFileImporter.processProperties(oDOM);

    const buttonSet = SportsCodeFileImporter.processButtonConfiguration(oDOM);
    console.info(`got ${buttonSet.buttons.length} buttons`);
    const events = SportsCodeFileImporter.processCodedEvents(oDOM, buttonSet.buttons);
    console.info(`got ${events.length} events`);

    match.events = events;
    return match;
  }
}
